import { render, staticRenderFns } from "./enterpriseincome_details.vue?vue&type=template&id=30addcd0&scoped=true&"
import script from "./enterpriseincome_details.vue?vue&type=script&lang=js&"
export * from "./enterpriseincome_details.vue?vue&type=script&lang=js&"
import style0 from "./enterpriseincome_details.vue?vue&type=style&index=0&id=30addcd0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30addcd0",
  null
  
)

export default component.exports